export default __webpack_public_path__ + "static/media/Keelay_Carter_AHV_In_Moms_We_Trust.ea5f2938.jpg";